import { ColumnDetails } from '../../../grid/types/common';
import { ActiveSchedules, Column, ColumnKeys } from '../types';
import { gridCustomHtmlRenderer } from '../../../grid/utils/renderers';
import { htmlEncode } from '../../../utils/escape.utils';
import { dateFormatter } from '@nirvana/shared/time';
import { LinkType } from '../../../ui/gzLinkComponent/types';
import { FontSizes } from '../../../types/common/types';
import { html } from 'lit';

export function permissionsRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  let className = 'dot green-dot';
  let fieldText = ' Shared';
  let style = 'height: 8px;width: 8px;border-radius: 50%;display: inline-block;background-color: green;';

  if (cellValue === false) {
    className = 'dot red-dot';
    fieldText = ' Not shared';
    style = 'height: 8px;width: 8px;border-radius: 50%;display: inline-block;background-color: red;';
  }

  return gridCustomHtmlRenderer(
    `<span class="cell-label"><span class="${className}" style="${style}"></span>${fieldText}</span>`
  );
}

export function inPoliciesRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  return gridCustomHtmlRenderer(`<span class="cell-label">${cellValue}</span>`);
}

export function scheduleDetailsRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  // defined in types
  const activeSchedules: ActiveSchedules = {};

  const useFallbackSchedule = rowData.item.specifics.scanPatchesSettings
    ? rowData.item.specifics.scanPatchesSettings.useFallbackSchedule
    : false;

  // add scan settings
  if (rowData.item.specifics.scanPatchesSettings && rowData.item.specifics.scanPatchesSettings.enabled) {
    activeSchedules.scanPatchesSettings = rowData.item.specifics.scanPatchesSettings;
  }

  // add security settings
  const securitySettingsAreEnabled =
    rowData.item.specifics.installPatchesSettings.updateType.securityPatchesSettings &&
    rowData.item.specifics.installPatchesSettings.updateType.securityPatchesSettings.enabled;

  if (securitySettingsAreEnabled) {
    activeSchedules.securityPatchesSettings =
      rowData.item.specifics.installPatchesSettings.updateType.securityPatchesSettings;
  }

  // add non security settings
  if (
    rowData.item.specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings &&
    rowData.item.specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings.enabled
  ) {
    activeSchedules.nonSecurityPatchesSettings =
      rowData.item.specifics.installPatchesSettings.updateType.nonSecurityPatchesSettings;
  }

  // add manually approved settings (if security not added)
  if (
    !securitySettingsAreEnabled &&
    rowData.item.specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings &&
    rowData.item.specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings.enabled
  ) {
    activeSchedules.manuallyApprovedPatchesSettings =
      rowData.item.specifics.installPatchesSettings.updateType.manuallyApprovedPatchesSettings;
  }

  const cellText = this.computeCellText(activeSchedules);
  const tooltipValue = this.buildTooltipValue(activeSchedules, useFallbackSchedule);

  return gridCustomHtmlRenderer(`
      <gz-tooltip class="cell-label" tooltipText="${htmlEncode(tooltipValue)}"><span>${cellText}</span></gz-tooltip>
  `);
}

export function lastModifiedRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  // TODO: check mock for date format
  const cellValue = rowData.item[columnDetails.key];

  const dateFormatted = dateFormatter(cellValue, '');

  return gridCustomHtmlRenderer(`<span class="cell-label">${dateFormatted}</span>`);
}

export function windowNameRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  return html`
    <gz-link
      type=${LinkType.QUIET}
      fontSize=${FontSizes.PARAGRAPH_12}
      @click="${() => this.editDocument(rowData.item)}"
    >
      ${cellValue}
    </gz-link>
  `;
}
